import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from '../../components/header/headerAppyShop';
import FooterAppyShop from '../../components/footer/footerAppyShop';
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { appyShopConfig } from "../../config";
import { config } from '../../config-merchant';
import { useTranslation } from "next-i18next";
import Meta from '../../components/meta/meta';
import styles from './contact.module.scss'
import { Formik, Form, Field } from 'formik';
import * as yup from "yup";
import { useRef, useState } from "react";
import { contactMerchant } from '../../services/contact-services';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import ModalShop from '../../components/modal/modal';
import { useRouter } from 'next/router';
import Loader from '../../components/loader/loader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Contact(props: { headerProps: HeaderProps }) {

    const { i18n } = useTranslation('common');
    const { t } = useTranslation('common');
    const router = useRouter();

    const [isSubmitClicked, setSubmitClicked] = useState<boolean>(false);
    const [isModalOpen, setModalOpen] = useState<boolean>(false);
    const [isLoading, setLoading] = useState<boolean>(false);
    const recaptcha = useRef("");

    const options = {
        autoClose: 3000,
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
    };


    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            await contactMerchant({ name: values.name, email: values.email, message: values.msg, object: values.object, language: i18n.language.toUpperCase(), recaptcha: recaptcha.current })
            setLoading(false);
            setModalOpen(true);
        } catch (e) {
            setLoading(false);
            toast(t('TOAST_UNEXPECTED_ERROR'), options);
        }
    }

    const handleCaptcha = (token) => {
        recaptcha.current = token;
    }

    const schema = yup.object({
        name: yup.string().min(2, t('ORDER_ERROR_NAME')).required(t('ORDER_MISSING_NAME')),
        email: yup.string().required(t('ORDER_MISSING_MAIL')).email(t('ORDER_ERROR_MAIL')),
        object: yup.string().required(t('CONTACT_OBJECT_ERROR')),
        msg: yup.string().min(10, t('CONTACT_MSG_ERROR_SHORT')).required(t('CONTACT_MSG_ERROR')),
    })

    return (
        <>
            <Meta
                title={"Contact"}
                description={config.shopSlogan[i18n.language]}
                image={config.merchantDomain + config.defaultMetaImage}
                metaRobots={true}
            />
            <HeaderAppyShop activepage={'contact'} headerProps={props.headerProps} />
            { isModalOpen &&
                <ModalShop
                    closePopup={() => setModalOpen(false)}
                    modalText={{ title: t('CONTACT_MODAL_TITLE'), subtitle: t('CONTACT_MODAL_SUBTITLE'), question: "", button1: t('PAYMENT_BUTTON') }}
                    actionbutton1={() => router.push('/home')}
                />}

            <div id={"main-bg-top"}><img src="/assets/svg/bg-o.svg" alt="Agroetica"/></div>
            <div id={"main-bg-bottom"}><img src="/assets/svg/bg-o.svg" alt="Agroetica"/></div>
            <main>

                <div className={`${styles['contact']} ${styles['custom']}`}>

                    <div className={styles["cover"]}>
                        <img src="/assets/images/AGR/contact-cover-1.png" alt="Agroetica"/>
                    </div>

                    <p className={styles['text']}>Vous avez une question, une remarque ?</p>
                    <p className={styles['text']}>N'hésitez pas à nous poser toutes vos questions, nous sommes là pour vous renseigner !</p>

                    <div className={styles["contact-text"]}>
                        <h2>{t('CONTACT_TITLE')}</h2>
                        <div className={styles["contact-form"]}>
                            <Formik
                                initialValues={{
                                    name: '',
                                    email: '',
                                    object: '',
                                    msg: '',
                                }}
                                onSubmit={handleSubmit}
                                validationSchema={schema}
                            >{({ errors }) => (
                                <Form>
                                    {(isSubmitClicked && errors.name) && <div className={styles['error-form']}>{errors.name}</div>}
                                    <Field name="name" type="text" placeholder={t('CONTACT_PH_NAME')} />
                                    {(isSubmitClicked && errors.email) && <div className={styles['error-form']}>{errors.email}</div>}
                                    <Field name="email" type="text" placeholder={t('CONTACT_PH_EMAIL')} />
                                    {(isSubmitClicked && errors.object) && <div className={styles['error-form']}>{errors.object}</div>}
                                    <Field name="object" type="text" placeholder={t('CONTACT_PH_OBJECT')} />
                                    {(isSubmitClicked && errors.msg) && <div className={styles['error-form']}>{errors.msg}</div>}
                                    <Field name="msg" component="textarea" placeholder={t('CONTACT_PH_MSG')} />
                                    <div className={styles["loader-place"]}>{isLoading && <Loader />}</div>
                                    <button type="submit" onClick={() => setSubmitClicked(true)}>{t('CONTACT_SEND_MSG')}</button>
                                </Form>)}
                            </Formik>
                            <GoogleReCaptchaProvider reCaptchaKey={appyShopConfig.reCaptchaKey}>
                                <GoogleReCaptcha
                                    onVerify={token => {
                                        handleCaptcha(token)
                                    }}
                                />
                            </GoogleReCaptchaProvider>
                        </div>
                    </div>
                </div>
            </main>
            <FooterAppyShop />
        </>
    );
}


export const getStaticProps = async ({ locale }) => {
    if (config.menu.some(item => item.path === 'contact') || config.footerLink.some(item => item.url === '/contact')) {
        return {
            props: {
                ...await serverSideTranslations(locale, ['common']),
                headerProps: await getComponentStaticProps(locale)
            },
            revalidate: appyShopConfig.revalidateData
        }
    } else {
        return {
            notFound: true
        }
    }

}
